var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.54698 0.41123L5.71202 6.58242C5.89952 6.80586 6.28331 6.80586 6.46934 6.58242L11.6358 0.411231C11.6486 0.396053 11.6562 0.37812 11.6579 0.359421C11.6595 0.340722 11.6552 0.321985 11.6453 0.305289C11.6355 0.288593 11.6205 0.27459 11.602 0.264831C11.5835 0.255072 11.5623 0.249938 11.5406 0.25L10.442 0.25C10.3673 0.25 10.297 0.281738 10.253 0.333789L6.09141 5.30527L1.92979 0.333788C1.88585 0.281737 1.81553 0.249999 1.74083 0.249999L0.642194 0.249999C0.54698 0.249999 0.491315 0.343945 0.54698 0.41123Z",
    fill: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.2b19f950.svg";
export { ForwardRef as ReactComponent };